import Image from 'next/image';

import type { FormInputProps } from '~components/Forms/common/types';

import {
	RatingContainer,
	RatingItem,
	RatingItemInput,
	RatingItemTitle,
} from './styles';

const rating = {
	1: 'Very poor',
	2: 'Poor',
	3: 'Average',
	4: 'Good',
	5: 'Excellent',
};

export const RatingField = <TFormValues extends Record<string, unknown>>({
	name,
	register,
	rules,
	...props
}: Omit<FormInputProps<TFormValues>, 'type'>) => {
	return (
		<RatingContainer>
			{Object.entries(rating).map(([key, value]) => (
				<RatingItem key={key}>
					<RatingItemInput
						type="radio"
						name={name}
						value={key}
						{...(register && register(name, rules))}
						{...props}
					/>
					<RatingItemTitle
						size="small"
						transparent={true}
						transform="uppercase"
						weight={600}
					>
						{value}
					</RatingItemTitle>
					<Image
						src={`/assets/rating/${key}.svg`}
						width={56}
						height={56}
						alt={value}
					/>
				</RatingItem>
			))}
		</RatingContainer>
	);
};
